// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3QSBp","label":"Completed_label__zcnSn"};